var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.gnbName == 'gnb' ? _c('div', {
    class: _vm.gnbName + '-wrap'
  }, [_c('ul', {
    class: [_vm.gnbName, _vm.gnbClass]
  }, [_vm._l(_vm.gnbs, function (item, i) {
    return [!item.children ? _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('router-link', {
      class: _vm.gnbName + '__link',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])]), _c(_vm.lnbTag, {
      tag: "component",
      staticClass: "lnb--empty"
    })], 1) : _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('router-link', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])]), _c(_vm.lnbTag, {
      tag: "component"
    }, _vm._l(item.children, function (child, j) {
      return _c('li', {
        key: j
      }, [child.href ? _c('a', {
        attrs: {
          "href": child.href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.title))]) : _c('router-link', {
        attrs: {
          "to": child.path
        }
      }, [_vm._v(_vm._s(child.title))])], 1);
    }), 0)], 1)];
  })], 2)]) : _vm.gnbName == 'gnb-mo' ? _c('div', {
    class: _vm.gnbName + '-wrap'
  }, [_c('ul', {
    class: [_vm.gnbName, _vm.gnbClass]
  }, [_vm._l(_vm.gnbs, function (item, i) {
    return [!item.children ? _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('router-link', {
      class: _vm.gnbName + '__link',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])])], 1) : _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('router-link', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])]), _c('v-btn', {
      staticClass: "v-btn--text-fit",
      class: _vm.gnbName + '__arrow'
    }, [_c('icon-chevron', {
      attrs: {
        "size": "x-small",
        "direction": "down"
      }
    })], 1), _c('ul', {
      class: _vm.gnbName + '__sub'
    }, [_vm._l(item.children, function (child, j) {
      return [!child.children ? _c('li', {
        key: j,
        class: _vm.gnbName + '__sub-item'
      }, [child.href ? _c('a', {
        class: _vm.gnbName + '__sub-link',
        attrs: {
          "href": child.href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.title))]) : _c('router-link', {
        class: _vm.gnbName + '__sub-link',
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])], 1) : _c('li', {
        key: j,
        class: _vm.gnbName + '__sub-item'
      }, [child.href ? _c('a', {
        class: _vm.gnbName + '__sub-link ' + _vm.gnbName + '__sub-link--toggle',
        attrs: {
          "href": child.href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.title))]) : _c('router-link', {
        class: _vm.gnbName + '__sub-link ' + _vm.gnbName + '__sub-link--toggle',
        attrs: {
          "to": child.path
        }
      }, [_vm._v(_vm._s(child.title))]), _c('ul', {
        class: _vm.gnbName + '__sub'
      }, _vm._l(child.children, function (grandChild) {
        return _c('li', {
          key: grandChild.title,
          class: _vm.gnbName + '__sub-item'
        }, [grandChild.href ? _c('a', {
          class: _vm.gnbName + '__sub-link',
          attrs: {
            "href": grandChild.href,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandChild.title))]) : _c('router-link', {
          class: _vm.gnbName + '__sub-link',
          attrs: {
            "to": grandChild.path
          }
        }, [_vm._v(_vm._s(grandChild.title))])], 1);
      }), 0)], 1)];
    })], 2)], 1)];
  })], 2)]) : _vm.gnbName == 'sitemap-menu' ? _c('div', {
    class: _vm.gnbName + '-wrap'
  }, [_c('ul', {
    class: [_vm.gnbName, _vm.gnbClass]
  }, [_vm._l(_vm.gnbs, function (item, i) {
    return [!item.children ? _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('router-link', {
      class: _vm.gnbName + '__link',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])])], 1) : _c('li', {
      key: i,
      class: _vm.gnbName + '__item'
    }, [item.href ? _c('a', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('router-link', {
      class: _vm.gnbName + '__link ' + _vm.gnbName + '__link--toggle',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])]), _c('ul', {
      class: _vm.gnbName + '__sub'
    }, [_vm._l(item.children, function (child, j) {
      return [!child.children ? _c('li', {
        key: j,
        class: _vm.gnbName + '__sub-item'
      }, [child.href ? _c('a', {
        class: _vm.gnbName + '__sub-link',
        attrs: {
          "href": child.href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.title))]) : _c('router-link', {
        class: _vm.gnbName + '__sub-link',
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])], 1) : _c('li', {
        key: j,
        class: _vm.gnbName + '__sub-item'
      }, [child.href ? _c('a', {
        class: _vm.gnbName + '__sub-link ' + _vm.gnbName + '__sub-link--toggle',
        attrs: {
          "href": child.href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.title))]) : _c('router-link', {
        class: _vm.gnbName + '__sub-link ' + _vm.gnbName + '__sub-link--toggle',
        attrs: {
          "to": child.path
        }
      }, [_vm._v(_vm._s(child.title))]), _c('v-btn', {
        staticClass: "v-btn--text-fit",
        class: _vm.gnbName + '__arrow'
      }, [_vm._t("arrow")], 2), _c('ul', {
        class: _vm.gnbName + '__sub'
      }, _vm._l(child.children, function (grandChild) {
        return _c('li', {
          key: grandChild.title,
          class: _vm.gnbName + '__sub-item'
        }, [grandChild.href ? _c('a', {
          class: _vm.gnbName + '__sub-link',
          attrs: {
            "href": grandChild.href,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandChild.title))]) : _c('router-link', {
          class: _vm.gnbName + '__sub-link',
          attrs: {
            "to": grandChild.path
          }
        }, [_vm._v(_vm._s(grandChild.title))])], 1);
      }), 0)], 1)];
    })], 2)], 1)];
  })], 2)]) : _vm.gnbName == 'sub-tab' ? _c('div', {
    class: _vm.gnbName + '-wrap'
  }, [_c('v-container', [_vm._l(_vm.gnbs, function (item) {
    return [item.title == _vm.itemTitle ? [_c(_vm.tabsTag, _vm._b({
      key: item.title,
      tag: "component"
    }, 'component', Object.assign({}, _vm.tabsAttrs), false), _vm._l(item.children, function (child) {
      return _c(_vm.tabTag, _vm._b({
        key: child.title,
        tag: "component",
        class: [_vm.tabActive == child.title ? 'v-tab--active' : '', _vm.tabAttrs.class],
        attrs: {
          "to": child.path,
          "exact-path": ""
        }
      }, 'component', _vm.tabAttrs, false), [_vm._v(_vm._s(child.title))]);
    }), 1)] : _vm._e()];
  })], 2)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }